/**
 * Ищем контейнер
 * @param target
 * @returns {*}
 */
function findContainer(target) {
	if (!target) return false;
	return document.querySelector(target)
}

/**
 * Вытаскиваем все дата атрибуты у элемента
 * @param node
 * @param isRemoveDataName
 * @returns {{}}
 */
function getDataAttributes(node, isRemoveDataName = false) {
	if (!node) return false;

	let obj = {},
		arr = [].filter.call(node.attributes, function (at) {
			return /^data-/.test(at.name);
		});

	if (arr.length) {
		arr.forEach(function (v) {
			let name = v.name;
			if (isRemoveDataName) name = name.slice(5);
			obj[name] = v.value
		});
	}

	return obj;
}

/**
 * Получаем массив из строки
 * @param string
 * @param isInt
 * @returns {*}
 */
function setParamArray(string, isInt = false) {
	let arr = string.split(',');

	if (isInt) {
		return arr.map((item) => {
			return parseInt(item)
		})
	} else {
		return  arr;
	}
}

export {findContainer, getDataAttributes, setParamArray}